export const parse = (x: unknown): string | null => {
  return x !== undefined && x !== null ? `${x}` : null;
};
